import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase/client";
import { useDataBase } from "../../context/DataBaseContext";

import Input from "../common/Input";
import TextArea from "../common/TextArea";
import Select from "../common/Select";
import ColorSwitcher from "../common/ColorSwitcher";
import ButtonPrimaryForm from "../common/ButtonPrimaryForm";
import { IconSave } from "../icons/Icons";

const Form = ({ onClose, dataEvent }) => {
  const [form, setForm] = useState([]);
  const [process, setProcess] = useState([]);
  const [secretaries, setSecretaries] = useState([]);

  const { getAudiencias } = useDataBase();

  useEffect(() => {
    const getProcesos = async () => {
      const procesos = await getProcess();
      setProcess(procesos);
    };
    getProcesos();

    const getSecretarios = async () => {
      const secretarios = await getSecretaries();
      setSecretaries(secretarios);
    };
    getSecretarios();
  }, []);

  useEffect(() => {
    // si la variable dataEvent tiene datos, se asignan al formulario
    if (
      dataEvent &&
      dataEvent !== undefined &&
      dataEvent !== null &&
      dataEvent.length !== 0
    ) {
      const { start, end } = dataEvent;
      const data = {
        ...dataEvent,
        start: start.split(" ")[1],
        end: end.split(" ")[1],
      };
      setForm(data);
    }
  }, []);

  const getProcess = async () => {
    try {
      const { data: process, error } = await supabase.from("process").select(`
                id,
                num_process,
                anio_process,
                class_process(
                    name
                )
            `);

      if (error) {
        console.log(error);
        return;
      }

      const processFormat = process.map((item) => ({
        id: item.id,
        name:
          item.num_process +
          "-" +
          item.anio_process +
          "-" +
          item.class_process.name,
      }));
      return processFormat;
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const getSecretaries = async () => {
    try {
      const { data: secretaries, error } = await supabase
        .from("secretaries")
        .select(
          `
                id,
                users(
                    first_name,
                   last_name
                  )
              `
        );

      if (error) {
        console.log(error);
        return [];
      }

      const secretariesFormat = secretaries.map((item) => ({
        id: item.id,
        name: item.users.first_name + "  " + item.users.last_name,
      }));

      return secretariesFormat;
    } catch (error) {
      console.error("Error fetching secretaries:", error);
      return [];
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleColorChange = (color) => {
    setForm({
      ...form,
      event_color: color,
    });
  };

  const handleClick = async (e) => {
    e.preventDefault();
    if (form.id && form.id !== undefined && form.id !== null) {
      const { error } = await supabase
        .from("audiences")
        .update([form])
        .eq("id", form.id);

      if (error) {
        console.log(error);
        return false;
      }
      console.log("Se modificaron los datos");
    } else {
      const { error } = await supabase.from("audiences").insert([
        {
          date: form.date,
          end: form.end,
          event_color: form.event_color,
          expiration_days: form.expiration_days,
          id_process: form.id_process,
          id_secretaries: form.id_secretaries,
          observations: form.observations,
          place: form.place,
          start: form.start,
          title: form.title,
          type: form.type,
        },
      ]);

      if (error) {
        console.log(error);
        return false;
      }
      console.log("Se insertaron los datos");
    }
    getAudiencias();
    onClose();
  };

  return (
    <form className="container p-4" onSubmit={handleClick}>
      <div className="grid grid-cols-2 gap-x-10 gap-y-2 mt-4 items-end">
        <Input
          textLabel={"Titulo: "}
          typeInput={"text"}
          name={"title"}
          className="w-3/4"
          value={form.title}
          onChange={(e) => handleInputChange(e)}
          required={false}
        />
        <Input
          textLabel={"Fecha: "}
          typeInput={"date"}
          name={"date"}
          className="w-3/4"
          value={form.date}
          onChange={(e) => handleInputChange(e)}
          required={false}
        />
        <Input
          textLabel={"Hora de Inicio: "}
          typeInput={"time"}
          name={"start"}
          className="w-3/4"
          value={form.start}
          onChange={(e) => handleInputChange(e)}
          required={false}
        />
        <Input
          textLabel={"Hora de finalización: "}
          typeInput={"time"}
          name={"end"}
          className="w-3/4"
          value={form.end}
          onChange={(e) => handleInputChange(e)}
          required={false}
        />
        <Input
          textLabel={"Lugar: "}
          typeInput={"text"}
          name={"place"}
          className="w-3/4"
          value={form.place}
          onChange={(e) => handleInputChange(e)}
          required={false}
        />
        <Input
          textLabel={"Tipo: "}
          typeInput={"text"}
          name={"type"}
          className="w-3/4"
          value={form.type}
          onChange={(e) => handleInputChange(e)}
          required={false}
        />
        <div className="flex items-end space-x-2">
          <div className="w-3/4">
            <Input
              textLabel={"Color: "}
              typeInput={"text"}
              name={"event_color"}
              value={form.event_color}
              onChange={(e) => handleInputChange(e)}
              required={false}
            />
          </div>
          <div className="w-1/4 flex items-center">
            <ColorSwitcher onColorChange={handleColorChange} />
          </div>
        </div>
        <Select
          textLabel={"Secretario: "}
          name={"id_secretaries"}
          className="w-3/4"
          value={form.id_secretaries}
          onChange={(e) => handleInputChange(e)}
          required={false}
          dataOptions={secretaries}
        />
        <Select
          textLabel={"Proceso: "}
          name={"id_process"}
          className="w-3/4"
          value={form.id_process}
          onChange={(e) => handleInputChange(e)}
          required={false}
          dataOptions={process}
        />
        <Input
          textLabel={"Días de expiración: "}
          typeInput={"number"}
          name={"expiration_days"}
          className="w-3/4"
          value={form.expiration_days}
          onChange={(e) => handleInputChange(e)}
          required={false}
        />
      </div>
      <div className="mt-4">
        <TextArea
          textLabel={"Observaciones: "}
          name={"observations"}
          className="w-[88%]"
          value={form.observations}
          onChange={(e) => handleInputChange(e)}
        />
      </div>
      <div className="flex justify-between items-center gap-2 mt-6">
        <div className="flex flex-col gap-2">
          <span className="text-red-500 text-xs italic">
            * Campos obligatorios
          </span>
        </div>
        <div className="flex gap-2 items-center">
          <ButtonPrimaryForm text={"Guardar"} typeBtn={"submit"}>
            <IconSave className="w-4" />
          </ButtonPrimaryForm>
        </div>
      </div>
    </form>
  );
};

export default Form;